import {
  CPSConfig,
  CPSConfigFunctionnality,
  HistoryChartModeEnum,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00032FunctionFinish } from './P00032/Installation/P00032InstallationFinish';
import { P00032InstallationReset } from './P00032/Installation/P00032InstallationReset';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P00032SenseStatusComponent } from './P00032/Sense/cps/p00032-sense-status/p00032-sense-status.component';
import { P00032CardSensStatutComponent } from './P00032/Sense/card/p00032-card-sens-statut/p00032-card-sens-statut.component';
import { P00032InstallationParametrageCapteursComponent } from './P00032/Installation/p00032-installation-parametrage-capteurs/p00032-installation-parametrage-capteurs.component';
import { P00032Alarm } from './P00032/Alarm/P00032Alarm';

export class P00032Data {
  snSDisponibiliteCapteurDebit: number = 0;

  snSEtatDebit: number = 0;

  snSPresenceDebit: number = 0;

  snSReceptionNouvelleMesure: number = 0;

  snSValiditeEtalonnageRx: number = 0;

  snSDefautSondeRx: number = 0;

  snSDisponibiliteMesureRx: number = 0;

  snSDisponibiliteMesureTemperature: number = 0;

  snSValiditeEtalonnagePh: number = 0;

  snSDefautSondePh: number = 0;

  snSDisponibiliteMesurePh: number = 0;

  snSEtatPile: number = 0;

  snSSourceAlimentation: number = 0;

  snSAlarme: number = 0;

  snSPreventionContreGel: number = 0;

  snSTensionPile: number = 0;

  snSentreeSondeRx: number = 0;

  snSMesureRxCompense: number = 0;

  snSConstanteSondeRx: number = 0;

  snSEtalonageRx: string = '00/00/0000';

  snSEntreeSondePh: number = 0;

  snSMesurePhCompenseCentieme: number = 0;

  snSMesurePhCompenseDixieme: number = 0;

  snSConstanteSondePh: number = 0;

  snSTauxAccroissement: number = 0;

  snSEtalonnagePh: string = '00/00/0000';

  snSTempsRestantPollingRapide: number = 0;

  snSMesureTemperatureEau: number = 0;

  snSValiditeTemperatureEau: number = 0;

  snSNombreSecondeTemperatureEleve: number = 0;

  snSCompteurResetCompteur: number = 0;

  snSCompteurResetUsine: number = 0;

  snSSecuriteMesureInjectionCl: number = 0;

  snSSecuriteMesureInjectionPh: number = 0;

  snCResetUsine: number = 0;

  snCResetCompteur: number = 0;

  snIConfigurationProduit: number = 0;

  snISondeRxInstalle: number = 0;

  snISondePhInstalle: number = 0;

  snIInstallationCapteurDebit: number = 0;

  snISensContactSecDebit: number = 0;
}

export class P00032 extends IProduct {
  override deviceTableIndex: number = 7;

  override modelIdentifier?: string = 'P00032';

  override dataIdentifier?: string = 'P00032';

  override manufacturerName?: string = 'ACWA';

  data: P00032Data = new P00032Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P00032/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P00032/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P00032/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P00032;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P00032?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P00032.tuto.installation.help.title',
      helpSlides: [
        'P00032.tuto.installation.help.1',
        'P00032.tuto.installation.help.2',
        'P00032.tuto.installation.help.3',
        'P00032.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00032/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00032/installation-1_dark.png',
          },
          text: 'P00032.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00032/installation-2.png',
            dark: '/assets/ecosystem/images/products/P00032/installation-2_dark.png',
          },
          text: 'P00032.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00032/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00032/installation-1_dark.png',
          },
          text: 'P00032.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P00032/update-2.png',
            dark: '/assets/ecosystem/images/products/P00032/update-2_dark.png',
          },
          text: 'P00032.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          {
            component: P00032InstallationParametrageCapteursComponent,
            condition: () => {
              return true;
            },
          },
        ],
        finish: P00032FunctionFinish,
        reset: P00032InstallationReset,
      },

      statusCards: [{ component: P00032CardSensStatutComponent, weight: 3 }],

      controlCards: [],

      alarms: {
        weight: 2,
        component: P00032Alarm,
      },

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.MEASURE];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality | EventProductFunctionnalityEnum,
  ): CPSConfigFunctionnality | null {
    if (
      functionnality == IProductFunctionnality.SENSE ||
      functionnality == EventProductFunctionnalityEnum.MEASURE
    ) {
      return {
        miseEnOeuvre: {
          pages: [],
        },
        controle: {
          enabledUser: false,
          enabledSupport: false,
          component: null,
        },
        parametrages: {
          enabledUser: false,
          enabledSupport: false,

          reglage: {
            enabledUser: false,
            enabledSupport: false,
            component: null,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          component: P00032SenseStatusComponent,
        },

        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            graphiques: [
              {
                title: 'P00032.historique.detectionDebit',
                mode: HistoryGraphModeEnum.EVENT,
                codeEvent: 432,
                yMode: HistoryGraphYModeEnum.HOUR,
                property: 'snSPresenceDebit',
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },
              {
                title: 'P00032.historique.redox',
                mode: HistoryGraphModeEnum.DATA,
                property: 'snSMesureRxCompense',
                aggregate: 'avg',
                yMode: HistoryGraphYModeEnum.MVOLT,
                yModeOptions: { min: 0, max: 1000 },
                chartMode: HistoryChartModeEnum.LINEAR,
              },
              {
                title: 'P00032.historique.ph',
                mode: HistoryGraphModeEnum.DATA,
                property: 'snSMesurePhCompenseDixieme',
                aggregate: 'avg',
                yMode: HistoryGraphYModeEnum.PH,
                yModeOptions: { min: 20, max: 120 },
                chartMode: HistoryChartModeEnum.LINEAR,
              },
              {
                title: 'P00032.historique.Teau',
                mode: HistoryGraphModeEnum.DATA,
                property: 'snSMesureTemperatureEau',
                aggregate: 'avg',
                yMode: HistoryGraphYModeEnum.TEMPERATURE,
                yModeOptions: { min: -50, max: 450 },
                chartMode: HistoryChartModeEnum.LINEAR,
                showDirectly: true,
              },
              {
                title: 'P00032.historique.tensionPile',
                mode: HistoryGraphModeEnum.DATA,
                property: 'snSTensionPile',
                aggregate: 'avg',
                yMode: HistoryGraphYModeEnum.VOLT,
                yModeOptions: { min: 0, max: 70 },
                chartMode: HistoryChartModeEnum.LINEAR,
              },
            ],
          },
        },
      };
    }
    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return null;
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 1;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).snIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.csv'
    );
  }
}
